import React from "react";
import { buybackSteps } from "../mock";

export default function Buyback() {
  return (
    <section id="buyback" data-testid="buyback-section" className="home-section" style={{ scrollMarginTop: 120,
      background: "radial-gradient(circle at 86% 8%, rgba(255,231,156,0.7), transparent 28%), linear-gradient(135deg, #fff1bd 0%, #f9b51d 42%, #ea5b17 100%)" }}>
      <div className="container grid items-start gap-10 lg:grid-cols-[0.9fr_1fr]">
        <div className="reveal">
          <p className="eyebrow" style={{ color: "var(--green-950)" }}>Bulk IT asset buyback</p>
          <h2 className="mt-3 font-heading font-extrabold leading-[1.06]"
              style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
            Corporate buyback for upgrades, relocations &amp; office clearance
          </h2>
          <p className="mt-4 text-[17px] font-medium" style={{ color: "rgba(31,74,56,0.78)" }}>
            For asset disposal, office dismantling and large inventory movement, Kapatia provides
            structured review and pickup coordination across Noida, Delhi, Gurgaon and Bangalore.
          </p>
        </div>

        <div className="grid gap-4">
          {buybackSteps.map((s, i) => (
            <article key={s.n} className="reveal grid grid-cols-[48px_1fr] gap-x-4 rounded-2xl border p-5"
                     style={{ transitionDelay: `${i * 70}ms`, background: "rgba(255,255,255,0.85)",
                              borderColor: "rgba(255,255,255,0.7)", boxShadow: "0 12px 28px rgba(148,61,13,0.14)" }}>
              <span className="row-span-2 grid h-[42px] w-[42px] place-items-center rounded-full font-heading text-[18px] font-semibold"
                    style={{ border: "2px solid #E8501A", color: "#E8501A", background: "transparent" }}>{s.n}</span>
              <strong className="font-heading text-[19px] font-extrabold" style={{ color: "var(--green-950)" }}>{s.title}</strong>
              <p className="col-start-2 mt-1 text-[15px]" style={{ color: "rgba(31,74,56,0.72)" }}>{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
